/*  from https://www.codementor.io/nedson/a-guide-to-handling-internet-disconnection-in-react-applications-rs7u9zpwn */
import React from 'react'
import ErrorModal from './components/ErrorModal/ErrorModal'
import Spinner from './components/Spinner/Spinner'
import tts from './lib/TTS.js'
import { exitApp, platformStoreSet } from '../../shared/helpers.js'

export default function (ComposedComponent) {
  class NetworkDetector extends React.Component {
    state = {
      isDisconnected: false,
      errorModalTitle: '',
      errorModalMessage: '',
      errorVisible: false,
      errorModalButtons: [],
      errorPath: null,
      offlineCount: 0,
    }

    componentDidMount() {
      this.handleConnectionChange()
      window.addEventListener('online', this.handleConnectionChange)
      window.addEventListener('offline', this.handleConnectionChange)
    }

    componentWillUnmount() {
      window.removeEventListener('online', this.handleConnectionChange)
      window.removeEventListener('offline', this.handleConnectionChange)
    }

    tryAgain() {
      const { errorPath } = this.state
      window.location.replace(errorPath)
    }

    setOfflineState() {
      this.setState(
        {
          errorPath: window.location.pathname,
          isDisconnected: true,
          errorModalTitle: `Connection Error`,
          errorModalMessage: `Unable to access the internet. Please connect and relaunch the app.`,
          errorVisible: true,
          spinnerVisible: false,
          offlineCount: this.state.offlineCount + 1,
          errorModalButtons: [
            {
              label: 'Exit',
              name: 'exitButton',
              onClick: () => {
                exitApp()
              },
            },
          ],
        },
        () =>
          tts.addTextToRead(`
            ${this.state.errorModalMessage}.
            Focused on ${this.state.errorModalButtons[0].label}`)
      )
    }

    handleConnectionChange = () => {
      const condition = navigator.onLine ? 'online' : 'offline'
      if (condition === 'online') {
        // if we're coming from disconnection -> reconnection

        const webPing = setInterval(() => {
          fetch('//www.pbs.org/otterhealthcheckpbs.html', {
            mode: 'no-cors',
          })
            .then(() => {
              this.setState(
                {
                  isDisconnected: false,
                  errorVisible: false,
                  spinnerVisible: false,
                  errorModalButtons: [],
                },
                () => {
                  return clearInterval(webPing)
                }
              )

              if (this.state.offlineCount > 0) {
                this.tryAgain()
                this.setState(
                  {
                    offlineCount: 0,
                  },
                  () => {
                    return clearInterval(webPing)
                  }
                )
              }
            })
            .catch(() => this.setState({ isDisconnected: true }))
        }, 2000)

        return
      } else {
        // if the browser detects we're offline, we display the modal
        this.setOfflineState()

        if (this.state.errorPath.indexOf('video-playback') > -1) {
          platformStoreSet(
            'connectionMessage',
            'You have reconnected to the internet.'
          )
        }
        return
      }
    }

    render() {
      const {
        isDisconnected,
        errorModalTitle,
        errorModalMessage,
        errorVisible,
        errorModalButtons,
        spinnerVisible,
      } = this.state

      return (
        <div>
          <Spinner visible={spinnerVisible} fullscreen={true} />
          {isDisconnected ? (
            <ErrorModal
              title={errorModalTitle}
              description={errorModalMessage}
              buttons={errorModalButtons}
              componentType="errorModal"
              visible={errorVisible}
              hideStationLogo={true}
              errorType="internet"
            />
          ) : (
            <ComposedComponent {...this.props} />
          )}
        </div>
      )
    }
  }

  return NetworkDetector
}
